import { useContext } from 'react';

import { Theme } from '@mui/material';

import {
  Button,
  Icons,
  Stack,
  colorOrToken,
  tokens,
} from '@cast/design-system';

import { GlobalTourStepProps, TourContext } from '../providers';

type Props = {
  steps: string[];
  type: string;
  globalTourStepProps?: Record<string, GlobalTourStepProps>;
};

export const TourFooterInitiate = ({
  steps,
  type,
  globalTourStepProps,
}: Props) => {
  const { isInitActive, startTour, dismiss } = useContext(TourContext);

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="flex-end"
      gap="16px"
    >
      {isInitActive && (
        // No suitable semantic token found: aqua is used as the brand accent color for interactive tour navigation; the fg.action group only exposes blue/green/red variants.
        <Button
          variant="text"
          onClick={() => dismiss(type)}
          sx={(theme: Theme) => ({
            color: colorOrToken('aqua.300', tokens.primitives.colors.aqua[300]),
            opacity: 0.4,
            ...theme.typography.P12M,
            px: 0,

            '&:hover': {
              opacity: 1,
              color: colorOrToken(
                'aqua.100',
                tokens.primitives.colors.aqua[100]
              ),
            },

            '&:active': {
              color: colorOrToken(
                'aqua.600',
                tokens.primitives.colors.aqua[600]
              ),
            },
          })}
          testId="dismiss-btn"
        >
          Close
        </Button>
      )}

      <Button
        variant="text"
        onClick={() => {
          startTour(type, steps, globalTourStepProps);
        }}
        endIcon={<Icons.ArrowRight />}
        // No suitable semantic token found: aqua is used as the brand accent color for interactive tour navigation; the fg.action group only exposes blue/green/red variants.
        sx={(theme: Theme) => ({
          color: colorOrToken('aqua.300', tokens.primitives.colors.aqua[300]),
          ...theme.typography.P12M,

          '& .MuiButton-endIcon': {
            marginLeft: 0,
          },

          '&:hover': {
            color: colorOrToken('aqua.100', tokens.primitives.colors.aqua[100]),
          },
          '&:active': {
            color: colorOrToken('aqua.600', tokens.primitives.colors.aqua[600]),
          },
        })}
        testId="start-btn"
      >
        Start the tour
      </Button>
    </Stack>
  );
};
